import {
  Box,
  Button,
  FormGroup,
  Grid,
  Hidden,
  Input,
  Typography,
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import moment from "moment";
import React, { useContext, useState } from "react";
import Accordion from "../../components/common/accordian";
import { NOT_AVAILABLE_TEXT } from "../../constants";
import ApplicationContext from "../../context/index";
import { useStyles } from "../proposal/indexFormStyles";
import { postWebService } from "../../helpers/server";
import { ToastContainer, toast } from "react-toastify";

function ProfileSection(props) {
  const {
    state: { profileDetails = null },
  } = useContext(ApplicationContext);
  const {
    classes: {
      bgGray,
      container,
      gutterTop,
      main,
      label,
      userAccount,
      wordBreak,
    },
    disabledAccordion = false,
  } = props;

  const [showError, setShowError] = useState(false);
  const [field, setField] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const renderField = (labelName, labelValue) => {
    return (
      <Box className={gutterTop} justifyContent={"left"} textAlign="left">
        <Typography variant={"body2"} gutterBottom className={label}>
          {labelName}
        </Typography>
        <Typography variant={"body2"} className={wordBreak}>
          {labelValue}
        </Typography>
      </Box>
    );
  };

  const handleChanges = (e, type) => {
    let { value } = e.target;
    setField({
      ...field,
      [type]: e.target.value,
    });
  };
  const handleSubmitBtn = async () => {
    if (field.newPassword !== field.confirmPassword) {
      setShowError(true);
    } else {
      try {
        const res = await postWebService("service/reset-password", field);
        toast.success(res?.data?.data?.msg);
      } catch (err) {
        toast.error(
          "Something went wrong, please try again with correct password"
        );
      }
    }
  };
  return (
    <Box className={main} m={5}>
      <Box container={"true"} justifyContent="center" className={container}>
        <Accordion
          title={"Service Centre Details"}
          disabled={disabledAccordion}
        >
          <Box direction="column" style={{ width: "100%" }} m={2}>
            <Grid container spacing={2}>
              <Grid container item md={5} direction="column">
                {renderField("Name", profileDetails?.name)}
                {renderField("Mobile", profileDetails?.mobile)}
              </Grid>

              <Hidden smDown>
                <Grid container item md={2} direction="column"></Grid>
              </Hidden>

              <Grid container item md={5} direction="column">
                {renderField("Email", profileDetails?.email)}

                {renderField(
                  "Address",
                  profileDetails?.address
                    ? `${profileDetails?.address?.address_line_1}, ${profileDetails?.city}, ${profileDetails?.state}, ${profileDetails?.pincode}`
                    : NOT_AVAILABLE_TEXT
                )}
              </Grid>
            </Grid>
          </Box>
        </Accordion>

        <Accordion title={"User Account Details"} disabled={disabledAccordion}>
          <Box direction="column" style={{ width: "100%" }}>
            {profileDetails?.user.map((item, index) => {
              return (
                <Box
                  direction="column"
                  className={`${userAccount} ${index % 2 === 0 && bgGray}`}
                  m={1}
                  p={2}
                >
                  <Grid container spacing={2}>
                    <Grid container item md={2} direction="column">
                      {renderField("Mobile", item.mobile)}
                    </Grid>
                    <Grid container item md={3} direction="column">
                      {renderField("Email", item?.email)}
                    </Grid>
                    <Grid container item md={2} direction="column">
                      {renderField("Password", "*******")}
                    </Grid>
                    {/* <Grid container item md={2} direction="column">
                      {renderField(
                        "Type",
                        item?.type === "P" ? "Primary" : "Secondary"
                      )}
                    </Grid> */}
                    <Grid container item md={2} direction="column">
                      {renderField(
                        "Creation Date",
                        moment(item?.created_at).format("DD-MM-YYYY")
                      )}
                    </Grid>
                    <Grid container item md={2} direction="column">
                      {renderField("Active", item?.is_active ? "Yes" : "No")}
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
          </Box>
        </Accordion>

        <Accordion
          title={"Bank Details"}
          defaultExpanded={true}
          disabled={false}
        >
          <Box direction="column" style={{ width: "100%" }} m={2}>
            <Grid container spacing={2}>
              <Grid container item md={5} direction="column">
                {renderField(
                  "Account Holder Name",
                  profileDetails?.neft?.beneficiary_name
                )}

                {renderField(
                  "Account Number",
                  profileDetails?.neft?.account_number
                )}

                {renderField("IFSC Code", profileDetails?.neft?.ifsc_code)}
              </Grid>

              <Hidden smDown>
                <Grid container item md={2} direction="column"></Grid>
              </Hidden>

              <Grid container item md={5} direction="column">
                {renderField("GST", profileDetails?.gst)}

                {renderField("PAN", profileDetails?.pan)}
              </Grid>
            </Grid>
          </Box>
        </Accordion>
        <Accordion
          title={"Reset Password"}
          defaultExpanded={true}
          disabled={false}
        >
          <Box style={{ width: "100%" }} m={2}>
            <FormGroup
              style={{ marginTop: "2rem", width: "50%", textAlign: "left" }}
            >
              <label className="form-control-label" htmlFor="password">
                Current Password
              </label>
              <Input
                id="password"
                placeholder="Enter the Current Password"
                onChange={(e) => handleChanges(e, "currentPassword")}
              />

              <label
                className="form-control-label"
                htmlFor="newPassword"
                style={{ marginTop: "1rem" }}
              >
                New Password
              </label>
              <Input
                id="newPassword"
                placeholder="Enter the New Password"
                onChange={(e) => handleChanges(e, "newPassword")}
              />

              <label
                className="form-control-label"
                htmlFor="confirmPassword"
                style={{ marginTop: "1rem" }}
              >
                Confirm Password
              </label>
              <Input
                id="confirmPassword"
                placeholder="Enter the Confirm Password"
                onChange={(e) => handleChanges(e, "confirmPassword")}
              />
              {showError && (
                <p style={{ color: "red", fontSize: "12px" }}>
                  Your new password or confirm password is not matching
                </p>
              )}
              <Button
                type="button"
                onClick={handleSubmitBtn}
                color="primary"
                style={{
                  marginTop: "2rem",
                  width: "fit-content",
                  backgroundColor: "#3C63FC",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                Submit
              </Button>
            </FormGroup>
          </Box>
        </Accordion>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(ProfileSection);
